import { DialogHeader } from "../../../../../shared/react/DialogHeader"
import { HoldingPermissionsApi } from "../api"
import { View } from "../state"
import { Cropping } from "./cropping/Cropping"
import { CroppingFilters } from "./cropping/CroppingFilters"
import { DialogFooter } from "./DialogFooter"
import { Header } from "./Header"
import { useHoldingPermissionsEditor } from "./hooks"
import { Invites } from "./invites/Invites"
import { Permissions } from "./permissions/Permissions"
import { Users } from "./users/Users"
import { UsersFilter } from "./UsersFilter"

interface Props {
    api: HoldingPermissionsApi
    close: (result?: any) => void
    initialView?: View
}

const components = {
    users: [Users, UsersFilter],
    permissions: [Permissions, UsersFilter],
    cropping: [Cropping, CroppingFilters],
    invites: [Invites, UsersFilter]
} as const

export function PermissionsDialog({ api, close, initialView }: Props) {

    const { state, dispatch } = useHoldingPermissionsEditor(api, initialView)
    const { loggedInUser: { ownerRole } } = state

    const props = { state, dispatch }

    const [Content, Filters] = components[state.view]

    return <div className="omnia-holding-permissions">

        <DialogHeader help={["holdingPermissions"]}>
            <i className="fa-solid fa-user-gear"></i>
            {
                ownerRole
                    ? <>Manage users and permissions for this holding</>
                    : <>Users and permissions</>
            }
        </DialogHeader>

        <div className="modal-body">
            <Header {...{ ...props, Filters }} />
            <Content {...props} />
        </div>

        <div className="modal-footer">

            <DialogFooter {...props} close={close} />

        </div>

    </div >

}
